// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"bc50a93c","227":"efc94562","307":"4287e35d","385":"f827c65c","431":"c5c98bdc","486":"fc547b35","650":"c3fe2ead","673":"08d9289e","695":"258c923e","741":"217f32f8","949":"bf66286f","978":"6abd0ec0","983":"3ced7e93"}[chunkId] + ".chunk.js";
};